import React from 'react';

interface MaterialIconProps {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

/**
 * Material Symbols图标组件
 * 用于显示Google Material Symbols图标库中的图标
 *
 * @param name - 图标名称 (如 'menu', 'close', 'arrow_forward')
 * @param className - 自定义CSS类名
 * @param style - 内联样式
 * @param onClick - 点击事件处理函数
 */
export const MaterialIcon: React.FC<MaterialIconProps> = ({ name, className = '', style, onClick }) => {
  return (
    <span className={`material-symbols-outlined ${className}`} style={style} onClick={onClick}>
      {name}
    </span>
  );
};

export default MaterialIcon;
